export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1507001952673-0ee6b327960f?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format",
  story: "https://images.unsplash.com/photo-1718668691088-ad203aff1f3e?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format",
  therapyHands:
    "https://images.unsplash.com/photo-1604881991720-f91add269bed?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format",
  therapyCouch:
    "https://images.unsplash.com/photo-1714976694810-85add1a29c96?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format",
  therapistPortrait:
    "https://images.unsplash.com/photo-1573497491208-6b1acb260507?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format",
  corporateLounge:
    "https://images.unsplash.com/photo-1768659347532-74d3b1efb0ae?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format",
  journalFlatlay:
    "https://images.pexels.com/photos/28536456/pexels-photo-28536456.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  audioPerson:
    "https://images.unsplash.com/photo-1625786682948-2168238883d2?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format",
  headphones:
    "https://images.unsplash.com/photo-1693895592595-9171d91a0f22?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format",
  calmWindow:
    "https://images.unsplash.com/photo-1545386673-7723f55e5490?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format",
};

export const MARQUEE_ITEMS = [
  "Unpack overwhelm",
  "Reclaim stillness",
  "Soften burnout",
  "Rest deeply",
  "Say it out loud",
  "Stay a little longer",
];

export const TOPICS = [
  {
    name: "Anxiety & Overwhelm",
    blurb: "When everything arrives at once.",
    icon: "cloud",
  },
  {
    name: "Workplace Burnout",
    blurb: "The slow leak you keep ignoring.",
    icon: "flame",
  },
  {
    name: "Self-Compassion",
    blurb: "Being on your own side, again.",
    icon: "heart",
  },
  {
    name: "Mindfulness Practices",
    blurb: "Small, doable moments of quiet.",
    icon: "wind",
  },
];

export const STORY_CAMPS = [
  {
    camp: "Base Camp · 0 m",
    title: "It began with two friends and a little light.",
    text: "Every good climb starts with a small, hopeful step. Ours began with two friends who happened to be walking the same trail: both teachers at heart, both busy helping others, both quietly glad to have found a good friend. We didn't know it yet, but the best thing that would happen to us was simply meeting someone who made the path feel lighter.",
  },
  {
    camp: "Camp 1 · 600 m · The Foothills",
    title: "We discovered how good it feels to be heard.",
    text: "It started simply: a bench, a long walk, a chat that ran well past bedtime. One of us would talk, and the other would listen with a whole heart. No rushing, no fixing, just warmth. Shoulders softened. Breathing slowed. We found that being truly heard is a kind of medicine, and that a shared load feels lighter within minutes.",
  },
  {
    camp: "Camp 2 · 1,400 m · The Forest Trail",
    title: "And then the laughter arrived.",
    text: "Soon our conversations began to sparkle. Worries turned into funny stories. Hard days became tales we told twice, just for the giggles. Nothing was being brushed aside. Things were simply getting lighter, together. Joy shared grows. Worries shared get lighter.",
  },
  {
    camp: "Camp 3 · 2,300 m · The River Crossing",
    title: "One calm river. One light breeze.",
    text: "We are not alike, and that is exactly why it worked. When one of us needed calm, the river was there. When we needed a smile, the breeze arrived. Neither had to change. Healing, we learned, comes in many gentle temperatures.",
  },
  {
    camp: "Camp 4 · 3,200 m · The Ridge",
    title: "That's when we realised we already had the tools.",
    text: "Years in classrooms and boardrooms had taught us how people learn, listen and grow. NLP gave us a way to look at the words, thoughts and patterns that run quietly in the background. And we had been practising all of it on each other, long before we gave it a name.",
  },
  {
    camp: "The Summit · 4,100 m",
    title: "Back of the Mind was born.",
    text: "We named it for the thoughts, beliefs and feelings that quietly shape our days, and for the joy of bringing them gently forward. We built it for anyone ready to feel lighter, and for teams who want to talk and work together with more ease. Not to fix you. To walk beside you, the way we walked beside each other.",
  },
];

export const PRINCIPLES = [
  {
    n: "i.",
    title: "Sit before you solve.",
    text: "Most people don't need an answer first. They need someone to sit beside them.",
  },
  {
    n: "ii.",
    title: "Let laughter in.",
    text: "Lightness is not avoidance. Sometimes it is the first sign of healing.",
  },
  {
    n: "iii.",
    title: "Say it out loud.",
    text: "A feeling named is a feeling that begins to move.",
  },
  {
    n: "iv.",
    title: "Stay a little longer.",
    text: "Healing happens in company, at its own pace, with no clock.",
  },
];

export const FOUNDERS = [
  {
    persona: "Zen · The calm river",
    creds: "NLP trainer · college teaching experience",
    text: "Steady and spacious. Holds the silence so you can finally hear yourself think.",
  },
  {
    persona: "Humour · The light breeze",
    creds: "Corporate trainer · marketing professor",
    text: "Quick to smile, quick to lift the room. Makes the heavy feel a little lighter.",
  },
];

export const OFFERINGS = [
  {
    title: "Individual Healing",
    text: "One-on-one online sessions that move at your pace — warm, practical and unhurried.",
    link: "/individual-healing",
    image: "therapyHands",
    cta: "Find your pace",
  },
  {
    title: "Corporate Solutions",
    text: "Workshops, team resets and wellbeing programs for workplaces that want to talk easier.",
    link: "/corporate-solutions",
    image: "corporateLounge",
    cta: "Bring us to work",
  },
  {
    title: "Quick Heals",
    text: "Fast, free self-rescue tools: grounding exercises, breathing resets and pocket guides.",
    link: "/quick-heals",
    image: "calmWindow",
    cta: "Breathe for a minute",
  },
];

export const BOOKING_SERVICES = [
  { id: "intro", label: "Free intro call", meta: "20 minutes · meet us, no strings" },
  { id: "session", label: "Individual session", meta: "50 minutes · one-to-one online" },
  { id: "extended", label: "Extended session", meta: "80 minutes · deeper work, gentler pace" },
];

export const TIME_SLOTS = ["09:00", "10:30", "13:00", "15:30", "17:00", "18:30"];

export const PRICING = [
  {
    name: "First hello",
    price: "Free",
    meta: "20-minute intro call",
    features: ["Meet your therapist", "Tell your story at your pace", "Plan the path together"],
  },
  {
    name: "The session",
    price: "$60",
    meta: "50 minutes · one-to-one",
    features: ["Video session, warm and practical", "Tools to take down the mountain", "Between-session note"],
    featured: true,
  },
  {
    name: "The long walk",
    price: "$95",
    meta: "80 minutes · extended",
    features: ["Space for deeper patterns", "Breath & somatic work included", "Gentle after-plan"],
  },
];

export const MODALITIES = [
  { title: "Person-centred talk therapy", text: "You lead, we walk beside. Most sessions are exactly this: a whole hour of being genuinely heard." },
  { title: "CBT-informed tools", text: "Simple ways to catch the thought patterns running in the back of the mind — and choose again." },
  { title: "Breath & somatic work", text: "Anxiety is a body event. We work with the body first: breath, posture, release." },
  { title: "NLP patterns", text: "Language shapes feeling. We look at the words you use, and the doors they quietly open or close." },
];

export const FAQS = [
  { cat: "Sessions & Confidentiality", q: "Is what I share actually confidential?", a: "Yes. Everything you share stays between us, within standard legal limits (risk of serious harm to yourself or others). We explain the full privacy picture in your free intro call, in plain words, before you commit to anything." },
  { cat: "Sessions & Confidentiality", q: "Are you licensed therapists?", a: "Honest answer: Back of the Mind offers coaching and NLP-based support, not licensed clinical care. For diagnoses, medication or clinical treatment we will always refer you onward — warmly, and with names." },
  { cat: "Sessions & Confidentiality", q: "How long is a session, and how many will I need?", a: "Sessions run 50 minutes (or 80 for extended work). Some people come once and leave lighter; most walk with us for 4–8 sessions. There is no script — we review progress together every few weeks." },
  { cat: "Payment & Insurance", q: "What does a session cost and how do I pay?", a: "Intro calls are free. Sessions are $60 (50 min) or $95 (80 min), billed per session by card or transfer. Sliding-scale spots are reserved for those who need them — just ask." },
  { cat: "Payment & Insurance", q: "Is therapy covered by my insurance?", a: "Because our work is coaching-based rather than clinical, most insurance plans don't cover it. We provide a clear invoice for every session so you can check your plan's wellness stipends or reimbursement options." },
  { cat: "Payment & Insurance", q: "What if I need to cancel or reschedule?", a: "Life happens. Reschedule or cancel free of charge up to 24 hours before your session; later than that we charge 50% of the fee, as the time was held only for you." },
  { cat: "Tech Setup", q: "What do I need for an online session?", a: "Very little: a stable internet connection, a space where you won't be overheard, and headphones if you like. Sessions run on a simple video link — no installs, no accounts. Your phone works fine too." },
  { cat: "Tech Setup", q: "What happens if the internet drops mid-session?", a: "We fall back to a phone call and finish the session there. If it fails completely, we simply reschedule the remainder — you will never lose the time." },
  { cat: "Products & Downloads", q: "How do I receive the digital product I bought?", a: "Instantly. Right after checkout, your download unlocks on screen and a copy lands in your inbox. Downloads don't expire — the files are yours for keeps." },
  { cat: "Products & Downloads", q: "What is your refund policy for digital products?", a: "If a workbook or audio guide didn't help at all, write to us within 14 days and we'll refund you — no interrogation, no hard feelings." },
  { cat: "Products & Downloads", q: "Can I use the workbooks and journals on paper?", a: "Yes — every PDF is print-friendly at A4 and Letter, and the card deck ships with phone-sized images for those who prefer screens." },
  { cat: "Sessions & Confidentiality", q: "Do you offer sessions in languages other than English?", a: "Our sessions run in English. If English is your second language, you are welcome to bring any words that feel more like home." },
];

export const HELPLINE_NOTE =
  "Back Of The Mind is not an emergency crisis intervention service. If you are in immediate distress, please contact your local helpline.";

export const SOS_STEPS = [
  { sense: "See", count: 5, hint: "Look around slowly. Name five things you can see — colours count." },
  { sense: "Touch", count: 4, hint: "Find four things you can feel. Chair, fabric, floor, air." },
  { sense: "Hear", count: 3, hint: "Listen for three sounds. Near ones, far ones, your own breath." },
  { sense: "Smell", count: 2, hint: "Two things you can smell — or two smells you love, from memory." },
  { sense: "Taste", count: 1, hint: "One thing you can taste. Sip of water works beautifully." },
];

export const GUIDES = [
  {
    name: "The 60-Second Unclench",
    meta: "Pocket card · jaw, shoulders, breath",
    file: "the-60-second-unclench.txt",
    body: [
      "THE 60-SECOND UNCLENCHEST — Back of the Mind",
      "",
      "1. Drop your shoulders. Literally let them fall. Pause 3 breaths.",
      "2. Unclench your jaw; let the tongue rest low. Pause 3 breaths.",
      "3. Breathe in through the nose for 4, out through the mouth for 6. x5",
      "4. Say quietly: 'This is hard, and I am doing it anyway.'",
      "5. Stand up and shake out your hands. Done.",
      "",
      "Back Of The Mind is not an emergency crisis intervention service.",
      "If you are in immediate distress, please contact your local helpline.",
    ].join("\n"),
  },
  {
    name: "Night Scan",
    meta: "Pre-sleep self-soothe · 6 lines",
    file: "night-scan.txt",
    body: [
      "NIGHT SCAN — a 6-line wind-down, Back of the Mind",
      "",
      "1. Body: where does today sit in your body? Loosen that spot as you exhale.",
      "2. Mind: what is the loudest thought? Write it in one line.",
      "3. Parking: what can wait until tomorrow? Park it, on purpose.",
      "4. Good: name one thing that was okay today. Small counts.",
      "5. Body again: scan head to toes, softening as you go.",
      "6. Permission: nothing more is needed from you tonight.",
      "",
      "Back Of The Mind is not an emergency crisis intervention service.",
      "If you are in immediate distress, please contact your local helpline.",
    ].join("\n"),
  },
  {
    name: "Panic First-Aid",
    meta: "For the middle of the wave",
    file: "panic-first-aid.txt",
    body: [
      "PANIC FIRST-AID — Back of the Mind",
      "",
      "Panic is a wave. It crests, it falls. Your only job is to ride it out.",
      "",
      "1. Feet flat. Press them into the floor. Say: 'I am here, in this room.'",
      "2. Longer out than in: in for 4, out for 8. Ten rounds, slowly.",
      "3. Cold water on wrists or face — it tells the body the emergency is over.",
      "4. 5-4-3-2-1 grounding: see 5, touch 4, hear 3, smell 2, taste 1.",
      "5. If the wave keeps coming back, that is a reason for support, not shame.",
      "",
      "Back Of The Mind is not an emergency crisis intervention service.",
      "If you are in immediate distress, please contact your local helpline.",
      "Find help worldwide: https://findahelpline.com",
    ].join("\n"),
  },
];
